/**
* @file 系统管理-操作日志
* */
<template>
  <div id="role">
    <custom-table ref="customTable" :has-organization="true" :customOptions="customOptions" :columns="columns"
      addText="">
      <template slot-scope="{item, row}">
        <div v-if="item.prop === 'created'">{{ row.created | filterTime }}</div>

        <!-- 浏览器：SVG品牌图标+名称 -->
        <div v-else-if="item.prop === 'browser'" class="log-cell-inline">
          <span class="log-svg-icon" v-html="getBrowserSvg(row.browser)"></span>
          <span>{{ row.browser || '-' }}</span>
        </div>

        <!-- 操作系统：SVG品牌图标+名称 -->
        <div v-else-if="item.prop === 'os'" class="log-cell-inline">
          <span class="log-svg-icon" v-html="getOsSvg(row.os)"></span>
          <span>{{ row.os || '-' }}</span>
        </div>

        <!-- 设备类型：SVG图标+名称 -->
        <div v-else-if="item.prop === 'deviceType'" class="log-cell-inline">
          <span class="log-svg-icon" v-html="getDeviceSvg(row.deviceType, row.os)"></span>
          <span>{{ getDeviceLabel(row.deviceType) }}</span>
        </div>

        <!-- IP地址 -->
        <div v-else-if="item.prop === 'ip'">
          <span v-if="row.ip" class="log-ip">{{ row.ip }}</span>
          <span v-else class="log-empty">-</span>
        </div>

        <!-- 地区：国家-省-市 完整显示 -->
        <div v-else-if="item.prop === 'ipAddress'">
          <span v-if="row.country || row.province || row.city" class="log-location">
            <template v-if="row.country">{{ row.country }}</template>
            <template v-if="row.province"> · {{ row.province }}</template>
            <template v-if="row.city"> · {{ row.city }}</template>
          </span>
          <span v-else-if="row.ipAddress">{{ row.ipAddress }}</span>
          <span v-else class="log-empty">-</span>
        </div>

        <!-- 登录平台 -->
        <div v-else-if="item.prop === 'loginPlatform'">
          <el-tag v-if="row.loginPlatform === 'ADMIN'" size="mini" type="" effect="plain">管理平台</el-tag>
          <el-tag v-else-if="row.loginPlatform === 'MINIPROGRAM'" size="mini" type="success" effect="plain">小程序</el-tag>
          <el-tag v-else-if="row.loginPlatform === 'DRIVER_APP'" size="mini" type="warning" effect="plain">司机端</el-tag>
          <el-tag v-else-if="row.loginPlatform === 'CHANNEL_APP'" size="mini" style="color:#722ED1;border-color:#D3ADF7;background:#F9F0FF" effect="plain">渠道端</el-tag>
          <span v-else class="log-empty">-</span>
        </div>

        <!-- 网络类型 -->
        <div v-else-if="item.prop === 'networkType'" class="log-cell-inline">
          <span class="log-svg-icon" v-html="getNetworkSvg(row.networkType)"></span>
          <span>{{ getNetworkLabel(row.networkType) }}</span>
        </div>

        <!-- 代理 -->
        <div v-else-if="item.prop === 'isProxy'">
          <el-tag v-if="row.isProxy" size="mini" type="warning">代理</el-tag>
          <el-tag v-else size="mini" type="info">直连</el-tag>
        </div>

        <!-- 设备品牌/型号 -->
        <div v-else-if="item.prop === 'deviceBrand'">
          <span v-if="row.deviceBrand || row.deviceModel">
            {{ row.deviceBrand }}<template v-if="row.deviceModel"> {{ row.deviceModel }}</template>
          </span>
          <span v-else class="log-empty">-</span>
        </div>

        <!-- 操作内容：高亮登录 -->
        <div v-else-if="item.prop === 'remarks'">
          <el-tag v-if="row.remarks && row.remarks.indexOf('登') > -1" size="mini" type="success" style="margin-right:4px">登录</el-tag>
          <span>{{ row.remarks || '-' }}</span>
        </div>

        <span v-else>{{ row[item.prop] || '-' }}</span>
      </template>
    </custom-table>
  </div>
</template>

<script>
export default {
  name: "role",
  data() {
    return {
      customOptions: {
        url: '/api/v1/manage/log',
        params: {
          page: 1,
          size: 20
        },
        search: [
          {
            type: 'input',
            field: 'operator',
            name: '操作人',
            value: ''
          },
          {
            type: 'input',
            field: 'remarks',
            name: '操作内容',
            value: ''
          },
          {
            type: 'datetime',
            field: 'created',
            name: '操作时间',
            value: [new Date().setHours(0, 0, 0, 0) - 3600 * 1000 * 24 * 30, new Date().setHours(23, 59, 59, 0)],
            dateProp: {
              start: 'createdStart',
              end: 'createdEnd'
            }
          }
        ]
      },
      columns: [
        { prop: 'operator', label: '操作人', minWidth: 80 },
        { prop: 'created', label: '操作时间', minWidth: 155 },
        { prop: 'loginPlatform', label: '来源', minWidth: 80 },
        { prop: 'remarks', label: '操作内容', minWidth: 180 },
        { prop: 'ip', label: 'IP地址', minWidth: 125 },
        { prop: 'ipAddress', label: '地区', minWidth: 160 },
        { prop: 'isp', label: '运营商', minWidth: 80 },
        { prop: 'browser', label: '浏览器', minWidth: 120 },
        { prop: 'os', label: '操作系统', minWidth: 120 },
        { prop: 'deviceType', label: '终端类型', minWidth: 90 },
        { prop: 'deviceBrand', label: '终端设备', minWidth: 100 },
        { prop: 'networkType', label: '网络', minWidth: 80 },
        { prop: 'isProxy', label: '代理', minWidth: 60 },
      ]
    }
  },
  methods: {
    // ===== 浏览器 SVG 品牌图标 =====
    getBrowserSvg(browser) {
      if (!browser || typeof browser !== 'string') return this._svgUnknown('#909399')
      const b = browser.toLowerCase()
      if (b.includes('chrome')) return '<svg viewBox="0 0 24 24" width="16" height="16"><circle cx="12" cy="12" r="10" fill="none" stroke="#4285F4" stroke-width="1.5"/><circle cx="12" cy="12" r="4" fill="#4285F4"/><path d="M12 8 L21.5 8" stroke="#DB4437" stroke-width="2" fill="none"/><path d="M8.5 14 L3.5 5.5" stroke="#0F9D58" stroke-width="2" fill="none"/><path d="M15.5 14 L10.5 22.5" stroke="#F4B400" stroke-width="2" fill="none"/></svg>'
      if (b.includes('firefox')) return '<svg viewBox="0 0 24 24" width="16" height="16"><circle cx="12" cy="12" r="10" fill="#FF7139" opacity="0.15"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.1 0 2.1.3 3 .8-.4.2-.7.5-.9.9-.5-.3-1.3-.5-2.1-.5-2.5 0-4.5 2-4.5 4.5 0 2.1 1.5 3.9 3.5 4.4.2.5.6.9 1.1 1.1-.3 0-.7.1-1 .1C7.1 16.3 4.5 13.5 4.5 12 4.5 8.1 7.9 5 12 5z" fill="#FF7139"/></svg>'
      if (b.includes('safari')) return '<svg viewBox="0 0 24 24" width="16" height="16"><circle cx="12" cy="12" r="10" fill="none" stroke="#006CFF" stroke-width="1.5"/><circle cx="12" cy="12" r="1.5" fill="#006CFF"/><path d="M12 12 L8 16" stroke="#006CFF" stroke-width="1.5"/><path d="M12 12 L16 8" stroke="#E44" stroke-width="1.5"/><line x1="12" y1="3" x2="12" y2="5" stroke="#006CFF" stroke-width="1"/><line x1="12" y1="19" x2="12" y2="21" stroke="#006CFF" stroke-width="1"/><line x1="3" y1="12" x2="5" y2="12" stroke="#006CFF" stroke-width="1"/><line x1="19" y1="12" x2="21" y2="12" stroke="#006CFF" stroke-width="1"/></svg>'
      if (b.includes('edge')) return '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M12 2C6.48 2 2 6.48 2 12c0 3.7 2 6.9 5 8.6.3-.5.5-1 .5-1.6 0-2-1.5-3.7-1.5-5.5C6 9.5 8.7 7 12 7c2.8 0 5.2 1.8 6 4.3.2-.8.3-1.5.3-2.3C18.3 5.4 15.5 2 12 2z" fill="#0078D4"/><path d="M18.3 14c-.4 2.5-2.3 4.5-4.8 5.2-1.5.4-3 .3-4.5-.4C10.2 20.8 12 22 14 22c4.1 0 7.5-2.9 8-6.8-.5.3-1.1.5-1.7.5-.7 0-1.4-.2-2-.7z" fill="#50E6FF"/></svg>'
      if (b.includes('wechat') || b.includes('micromessenger')) return '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M8.5 6C4.9 6 2 8.5 2 11.5c0 1.7.9 3.2 2.3 4.2L3.8 18l2.5-1.3c.7.2 1.4.3 2.2.3.3 0 .5 0 .8-.1-.2-.5-.3-1-.3-1.4 0-2.8 2.7-5 6-5 .3 0 .5 0 .8.1C15.2 7.9 12.2 6 8.5 6z" fill="#07C160"/><circle cx="6.5" cy="10.5" r="0.8" fill="#fff"/><circle cx="10.5" cy="10.5" r="0.8" fill="#fff"/><path d="M22 15.5c0-2.5-2.5-4.5-5.5-4.5S11 13 11 15.5s2.5 4.5 5.5 4.5c.6 0 1.2-.1 1.8-.3l2 1-.5-1.8c1.3-.9 2.2-2.2 2.2-3.9z" fill="#07C160"/><circle cx="14.5" cy="15" r="0.7" fill="#fff"/><circle cx="18" cy="15" r="0.7" fill="#fff"/></svg>'
      if (b.includes('qq')) return '<svg viewBox="0 0 24 24" width="16" height="16"><ellipse cx="12" cy="12" rx="8" ry="9" fill="#12B7F5" opacity="0.15"/><path d="M12 3c-3.3 0-6 2.2-6 5v4c0 2.8 2.7 5 6 5s6-2.2 6-5V8c0-2.8-2.7-5-6-5z" fill="#12B7F5"/><circle cx="10" cy="9" r="1.2" fill="#fff"/><circle cx="14" cy="9" r="1.2" fill="#fff"/><circle cx="10" cy="9" r="0.6" fill="#333"/><circle cx="14" cy="9" r="0.6" fill="#333"/></svg>'
      if (b.includes('opera')) return '<svg viewBox="0 0 24 24" width="16" height="16"><circle cx="12" cy="12" r="10" fill="#FF1B2D" opacity="0.15"/><ellipse cx="12" cy="12" rx="4" ry="7" fill="none" stroke="#FF1B2D" stroke-width="2"/><circle cx="12" cy="12" r="10" fill="none" stroke="#FF1B2D" stroke-width="1.5"/></svg>'
      return this._svgUnknown('#909399')
    },

    // ===== 操作系统 SVG 品牌图标 =====
    getOsSvg(os) {
      if (!os || typeof os !== 'string') return this._svgUnknown('#909399')
      const o = os.toLowerCase()
      if (o.includes('windows')) return '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M3 12.5l7.5-1V5L3 6.3V12.5z" fill="#00ADEF"/><path d="M11.5 4.8L21 3.3V11.5h-9.5V4.8z" fill="#00ADEF"/><path d="M3 13.5l7.5 1V21L3 19.7V13.5z" fill="#00ADEF"/><path d="M11.5 14.7V21.2L21 22.7V14.5h-9.5z" fill="#00ADEF"/></svg>'
      if (o.includes('mac')) return '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M18.7 13c0 3.3-2.3 6.8-4.7 6.8-1 0-1.5-.5-2.5-.5s-1.6.5-2.5.5C6.5 19.8 4.3 16 4.3 13c0-2.8 1.8-4.5 3.5-4.5 1 0 1.8.5 2.5.5.6 0 1.6-.6 2.8-.5.5 0 2 .2 2.9 1.4-2.5 1.5-2.1 5.3.7 6.1zM14.5 4.2c-1.2.1-2.6 1-3.2 2-.5.9-.8 2 .1 2.3 1.2-.1 2.5-1 3.1-2 .5-.8.8-2 0-2.3z" fill="#333"/></svg>'
      if (o.includes('ios') || o.includes('iphone') || o.includes('ipad')) return '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M18.7 13c0 3.3-2.3 6.8-4.7 6.8-1 0-1.5-.5-2.5-.5s-1.6.5-2.5.5C6.5 19.8 4.3 16 4.3 13c0-2.8 1.8-4.5 3.5-4.5 1 0 1.8.5 2.5.5.6 0 1.6-.6 2.8-.5.5 0 2 .2 2.9 1.4-2.5 1.5-2.1 5.3.7 6.1zM14.5 4.2c-1.2.1-2.6 1-3.2 2-.5.9-.8 2 .1 2.3 1.2-.1 2.5-1 3.1-2 .5-.8.8-2 0-2.3z" fill="#333"/></svg>'
      if (o.includes('android')) return '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M6 10v6c0 .6.4 1 1 1h1v3c0 .6.4 1 1 1s1-.4 1-1v-3h4v3c0 .6.4 1 1 1s1-.4 1-1v-3h1c.6 0 1-.4 1-1v-6H6z" fill="#3DDC84"/><rect x="4" y="10" width="2" height="6" rx="1" fill="#3DDC84"/><rect x="18" y="10" width="2" height="6" rx="1" fill="#3DDC84"/><path d="M7 10c0-2.8 2.2-5 5-5s5 2.2 5 5H7z" fill="#3DDC84"/><circle cx="9.5" cy="7.5" r="0.7" fill="#fff"/><circle cx="14.5" cy="7.5" r="0.7" fill="#fff"/><line x1="8" y1="2" x2="9.5" y2="5" stroke="#3DDC84" stroke-width="0.8"/><line x1="16" y1="2" x2="14.5" y2="5" stroke="#3DDC84" stroke-width="0.8"/></svg>'
      if (o.includes('linux')) return '<svg viewBox="0 0 24 24" width="16" height="16"><ellipse cx="12" cy="13" rx="5" ry="6" fill="#FCC624" opacity="0.2"/><path d="M12 4c-2.2 0-4 2.2-4 5 0 1.5.4 2.8 1 3.8-.8.8-1.5 2-2 3.2h10c-.5-1.2-1.2-2.4-2-3.2.6-1 1-2.3 1-3.8 0-2.8-1.8-5-4-5z" fill="#333"/><circle cx="10.5" cy="8" r="1" fill="#fff"/><circle cx="13.5" cy="8" r="1" fill="#fff"/><circle cx="10.5" cy="8" r="0.4" fill="#333"/><circle cx="13.5" cy="8" r="0.4" fill="#333"/><path d="M10 11c.3.5 1 .8 2 .8s1.7-.3 2-.8" fill="none" stroke="#FCC624" stroke-width="0.8"/></svg>'
      return this._svgUnknown('#909399')
    },

    // ===== 设备类型 SVG 图标（根据OS着色）=====
    getDeviceSvg(type, os) {
      const color = this._getOsColor(os)
      if (!type || type === 'PC') return '<svg viewBox="0 0 24 24" width="16" height="16"><rect x="3" y="4" width="18" height="12" rx="2" fill="none" stroke="' + color + '" stroke-width="1.5"/><line x1="8" y1="20" x2="16" y2="20" stroke="' + color + '" stroke-width="1.5" stroke-linecap="round"/><line x1="12" y1="16" x2="12" y2="20" stroke="' + color + '" stroke-width="1.5"/></svg>'
      if (type === 'Mobile') return '<svg viewBox="0 0 24 24" width="16" height="16"><rect x="6" y="2" width="12" height="20" rx="2.5" fill="none" stroke="' + color + '" stroke-width="1.5"/><line x1="9" y1="4" x2="15" y2="4" stroke="' + color + '" stroke-width="1" stroke-linecap="round"/><circle cx="12" cy="19" r="1" fill="' + color + '"/></svg>'
      if (type === 'Tablet') return '<svg viewBox="0 0 24 24" width="16" height="16"><rect x="4" y="3" width="16" height="18" rx="2" fill="none" stroke="' + color + '" stroke-width="1.5"/><circle cx="12" cy="18.5" r="1" fill="' + color + '"/></svg>'
      if (type === 'MiniProgram') return '<svg viewBox="0 0 24 24" width="16" height="16"><circle cx="12" cy="12" r="10" fill="#07C160" opacity="0.15"/><path d="M8.5 7C5.6 7 3 9 3 11.5c0 1.4.8 2.7 2 3.5l-.4 2 2-1c.6.2 1.3.3 1.9.3h.5c-.1-.3-.1-.7-.1-1 0-2.5 2.5-4.5 5.5-4.5h.5C14.4 8.5 11.7 7 8.5 7z" fill="#07C160"/><path d="M21 15.5c0-2.2-2.2-4-5-4s-5 1.8-5 4 2.2 4 5 4c.5 0 1-.1 1.5-.2l1.5.7-.3-1.5c1.4-.8 2.3-1.8 2.3-3z" fill="#07C160"/></svg>'
      return '<svg viewBox="0 0 24 24" width="16" height="16"><rect x="3" y="4" width="18" height="12" rx="2" fill="none" stroke="' + color + '" stroke-width="1.5"/><line x1="8" y1="20" x2="16" y2="20" stroke="' + color + '" stroke-width="1.5" stroke-linecap="round"/><line x1="12" y1="16" x2="12" y2="20" stroke="' + color + '" stroke-width="1.5"/></svg>'
    },

    // ===== 网络类型 SVG 图标 =====
    getNetworkSvg(type) {
      if (!type) return this._svgUnknown('#909399')
      if (type === 'WIFI') return '<svg viewBox="0 0 24 24" width="16" height="16"><path d="M12 18c-.8 0-1.5.7-1.5 1.5S11.2 21 12 21s1.5-.7 1.5-1.5S12.8 18 12 18z" fill="#409EFF"/><path d="M2.1 9.3C5 6.5 8.3 5 12 5s7 1.5 9.9 4.3" fill="none" stroke="#409EFF" stroke-width="1.5" stroke-linecap="round"/><path d="M5.3 12.5C7.1 10.7 9.4 9.7 12 9.7s4.9 1 6.7 2.8" fill="none" stroke="#409EFF" stroke-width="1.5" stroke-linecap="round"/><path d="M8.5 15.7c1-1 2.2-1.5 3.5-1.5s2.5.5 3.5 1.5" fill="none" stroke="#409EFF" stroke-width="1.5" stroke-linecap="round"/></svg>'
      if (type === 'CELLULAR') return '<svg viewBox="0 0 24 24" width="16" height="16"><rect x="3" y="14" width="3" height="6" rx="0.5" fill="#E6A23C"/><rect x="8" y="10" width="3" height="10" rx="0.5" fill="#E6A23C"/><rect x="13" y="6" width="3" height="14" rx="0.5" fill="#E6A23C"/><rect x="18" y="2" width="3" height="18" rx="0.5" fill="#E6A23C"/></svg>'
      if (type === 'BROADBAND') return '<svg viewBox="0 0 24 24" width="16" height="16"><rect x="2" y="8" width="20" height="8" rx="2" fill="none" stroke="#67C23A" stroke-width="1.5"/><circle cx="6" cy="12" r="1" fill="#67C23A"/><circle cx="10" cy="12" r="1" fill="#67C23A"/><line x1="14" y1="10" x2="20" y2="10" stroke="#67C23A" stroke-width="1" stroke-linecap="round"/><line x1="14" y1="12" x2="20" y2="12" stroke="#67C23A" stroke-width="1" stroke-linecap="round"/><line x1="14" y1="14" x2="18" y2="14" stroke="#67C23A" stroke-width="1" stroke-linecap="round"/></svg>'
      return this._svgUnknown('#909399')
    },

    // ===== 工具方法 =====
    _svgUnknown(color) {
      return '<svg viewBox="0 0 24 24" width="16" height="16"><circle cx="12" cy="12" r="9" fill="none" stroke="' + color + '" stroke-width="1.5"/><text x="12" y="16" text-anchor="middle" font-size="12" fill="' + color + '">?</text></svg>'
    },
    _getOsColor(os) {
      if (!os) return '#909399'
      const o = os.toLowerCase()
      if (o.includes('windows')) return '#00ADEF'
      if (o.includes('mac') || o.includes('ios')) return '#333333'
      if (o.includes('android')) return '#3DDC84'
      if (o.includes('linux')) return '#FCC624'
      return '#909399'
    },
    getDeviceLabel(type) {
      if (!type) return '-'
      const map = { 'PC': '电脑', 'Mobile': '手机', 'Tablet': '平板', 'MiniProgram': '小程序' }
      return map[type] || type
    },
    getNetworkLabel(type) {
      if (!type) return '-'
      const map = { 'WIFI': 'WiFi', 'CELLULAR': '蜂窝', 'BROADBAND': '宽带', 'UNKNOWN': '未知' }
      return map[type] || type
    }
  }
}
</script>

<style scoped>
.log-cell-inline {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.log-svg-icon {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  line-height: 1;
}
.log-empty {
  color: #C0C4CC;
}
.log-ip {
  font-family: 'SF Mono', 'Monaco', 'Consolas', monospace;
  font-size: 12px;
  color: #606266;
}
.log-location {
  font-size: 12px;
  color: #303133;
}
</style>